import {Component, OnInit} from '@angular/core';
import {AssistanceApplicationType, User} from '../../../services/api.client';
import {PledgeType} from '../../../services/api.client';
import {SystemService} from '../../../services/SystemService';
import {Observable} from 'rxjs';
import {SecurityService} from '../../../services/SecurityService';
import {environment} from '../../../../environments/environment';
import {AssistanceApplicationService} from '../../public/application/assistance-application.service';

@Component({
    selector: 'sidebar,[sidebar]',
    templateUrl: './SidebarComponent.html',
    styleUrls: ['./SidebarComponent.scss'],
    standalone: false
})
export class SidebarComponent implements OnInit {
  protected readonly AssistanceApplicationType = AssistanceApplicationType;
  pledgeTypes: PledgeType[] = [];
  pledgeTypes$: Observable<PledgeType[]>;
  hasKeepingCurrent: boolean;
  hasUwdaFundType: boolean;
  hasEfs: boolean;
  hasEfs$: Observable<boolean>;
  user$: Observable<User>;
  user: User;

  hasEfn = false;
  hasEfn$: Observable<boolean>;

  // Collapsible nav sections (ngx-bootstrap collapse; independent, all start closed).
  sectionCollapsed: { [key: string]: boolean } = {
    uhons: true, reports: true, support: true, users: true
  };

  toggleSection(key: string): void {
    this.sectionCollapsed[key] = !this.sectionCollapsed[key];
  }

  constructor(public system: SystemService, private assistanceApplicationService: AssistanceApplicationService,
              private _securityService: SecurityService) {
    this.pledgeTypes$ = this._securityService.pledgeTypes$;
    this.hasEfs$ = this._securityService.currentUserHasEfs$;
    this.hasEfn$ = this._securityService.currentUserHasEfn$;
    this.user$ = this._securityService.currentUser$;
  } // we use this inject in the template for all the security checks

  public shouldShowApplications(_assistanceApplicationType: AssistanceApplicationType): boolean {
    return (this.hasKeepingCurrent || this.user.programAccess.length > 0)
        && !environment.appConfig?.disableApplicationsFeature;
  }

  public shouldShowNonKcApplication(assistanceApplicationType: AssistanceApplicationType): boolean {
    if (!this.user?.programAccess?.length || environment.appConfig?.disableApplicationsFeature) {
      return false;
    }

    return this.assistanceApplicationService.hasAccess(assistanceApplicationType, this.user);
  }

  ngOnInit(): void {
    this.pledgeTypes$.subscribe(pledgeTypes => this.pledgeTypes = pledgeTypes);
    this.hasEfs$.subscribe(hasEfs => this.hasEfs = hasEfs);
    this.hasEfn$.subscribe(hasEfn => this.hasEfn = hasEfn);
    this.user$.subscribe(user => this.user = user);
    this.hasKeepingCurrent = this.pledgeTypes.some(p => p.isKeepingCurrent);
    this.hasUwdaFundType = this.pledgeTypes.some(p => p.isUwda);
  }

  showUwdaMenu(): boolean {
    // Delegates to the shared predicate so this link and the CanAccessUwdaPledgesGuard
    // route guard always agree on who may reach the UWDA Pledges page.
    return this.system.canAccessUwdaPledges();
  }
}
